<template>
  <header class="site-header site-header--active-white">
    <div class="site-header__wrapper">
      <nav class="site-header__navigation">
        <a href="/" class="site-header__logotype">
          <img
              v-if="logotype?.logotypeUrl"
              :src="logotype.logotypeUrl"
              :alt="translations['bookings.header.logotype.alt']"/>
        </a>
        <div class="site-header__links">
          <LanguagePicker v-if="!isAuthenticated || isAuthenticated && !isBusinessCustomer" class="site-header__link site-header__link--language-picker"/>
          <AccountMenu v-if="isAuthenticated && isSluiceHost" :menu-items="sluiceHostMenuItems" class="site-header__link" />
          <AccountMenu v-else-if="isAuthenticated && !isSluiceHost" :menu-items="menuItems" class="site-header__link" />
          <LoginLink v-if="!isAuthenticated" class="site-header__link"/>
          <a :href="getBookingRouteUrl(RouteNames.ContactInformation)" class="site-header__link site-header__contact-link">
            <span class="site-header__contact-icon icon icon--phone"></span>
            {{ translations['bookings.header.contact'] }}
          </a>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {useApi} from "@shared/Services/axios-service";
import {getTranslations} from "@shared/Services/translations";
import AccountMenu from "@shared/Layout/SiteHeader/AccountMenu/AccountMenu.vue";
import LanguagePicker from "@shared/Layout/SiteHeader/LanguagePicker/LanguagePicker.vue";
import LoginLink from "@shared/Layout/SiteHeader/LoginLink/LoginLink.vue";
import {useAuth} from "@services/authentication";
import { getBookingRouteUrl } from "@services/booking-route-service";
import { RouteNames } from "@services/booking-route-service";

const translations = getTranslations();
const {data: logotypeData, get: getHeaderLogotype} = useApi<HeaderLogotype>("/layout/logotype");
const logotype = ref<HeaderLogotype | null>(null);
const auth = useAuth();
const isAuthenticated = computed(() => auth.isAuthenticated());
const isBusinessCustomer = computed(() => auth.isBusinessCustomer());
const isSluiceHost = computed(() => auth.isSluiceHost());

const menuItems: MenuItem[] = [
  { linkText: translations["bookings.accountmenu.mybookings"], routeName: RouteNames.MyBookings },
  { linkText: translations["bookings.accountmenu.mysettings"] ?? "My settings", routeName: RouteNames.MySettings },
  { linkText: translations["bookings.accountmenu.myboatdetails"] ?? "My boat details", routeName: RouteNames.ManageBoats },
  { linkText: translations['bookings.accountmenu.bookingsstart'], routeName: RouteNames.SelectTicket },
];

const sluiceHostMenuItems: MenuItem[] = [
  { linkText: translations['bookings.accountmenu.sluicehost.bookings'], routeName: RouteNames.SluiceHost },
  { linkText: translations['bookings.accountmenu.sluicehost.bookingsstart'], routeName: RouteNames.SelectTicket }
];

onMounted(() => {
  getHeaderLogotype().then(() => {
    logotype.value = logotypeData.value ?? null;
  });
});
</script>
